import React from 'react';
import {registerLocale} from 'react-datepicker';
import nl from 'date-fns/locale/nl';
import styled from 'styled-components';
import {datePickerDropdownType} from '../../../form-mixin/datePickerDropdownType';
import {InputStructure, InputWrapper} from '../../input/type/InputStructure';
import {Icon} from '../../../../elements/Icon/Icon';
import {FormControlWrapper} from '../../../form-control/FormControlStructure';
import {WordFix} from '../../../form-features/labels/WordFix';
import {DatepickerStyling} from './DatepickerStyling';
registerLocale('nl', nl);

function DatePickerStructure({label, disabled, children, nonePrefix, ...props}) {
    return (
        <InputStructure
            nonePrefix={nonePrefix}
            disabled={disabled}
            prefix={<Icon name="Event" color="var(---form-word-fix-text-color)" />}
            {...props}
            label={label}>
            <Wrapper>{children}</Wrapper>
        </InputStructure>
    );
}

export const Wrapper = styled(DatepickerStyling)`
    .react-datepicker-popper {
        z-index: var(--z-index-dropdown);
        min-width: 360px;
    }
    .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,
    .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,
    .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::after,
    .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::after {
        left: -30px;
    }
    ${({weekbasis, dateAndTime}) => datePickerDropdownType(weekbasis, dateAndTime)};
`;

export const RawDatePickerWrapper = styled.div`
    ${WordFix} {
        position: absolute;
        z-index: 1;
        pointer-events: none;
        bottom: 0px;
        left: 0px;
    }
    ${({nonePrefix}) => {
        if (nonePrefix) {
            return `
            ${FormControlWrapper} {
                .react-datepicker__input-container button {
                    padding: 0 var(--padding-form-control-horz);
                }
                ${InputWrapper} {
                    border-left: 1px solid var(--form-control-border-color);
                }
            }
            ${WordFix} {
                display: none !important;
            }`;
        } else {
            return ` `;
        }
    }}
`;
export {DatePickerStructure};
